import { render, staticRenderFns } from "./DwDetail.vue?vue&type=template&id=3d0a3dfe&scoped=true&"
import script from "./DwDetail.vue?vue&type=script&lang=js&"
export * from "./DwDetail.vue?vue&type=script&lang=js&"
import style0 from "./DwDetail.vue?vue&type=style&index=0&id=3d0a3dfe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0a3dfe",
  null
  
)

export default component.exports